import { AccountBDL } from '../bdl/account';

export const AccountServices = () => {
  const { removeAccount, checkAccount } = AccountBDL();
  return ({
    removeAccount: async (id: string, password: string, motif: string) => await removeAccount(id, password, motif),
    checkAccount: async (email: string, password: string) => await checkAccount(email, password),
  });
};
